export default "__VITE_ASSET__c029d9ed__"